import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import OpenEffect from 'UIKit/OpenEffect'
import { useIsDisabledFeaturedOnTelegram } from 'hooks/useTelegram'
import Column from 'layout/Components/Column'
import { useState } from 'react'
import { useTokenSelected } from 'state/session/hooks'
import WarningOnTelegram from 'views/Authentication/components/Wallet/WarningOnTelegram/WarningOnTelegram'
import { DepositOptionEnums, PaymentPageEnums } from 'views/Payment/Menu'
import { DepositOptionContent } from 'views/Payment/MobilePayment/components/PaymentDepositOptions'
import { PAYMENT_MODAL_THEME } from 'views/Payment/MobilePayment/components/styles'
import { ICommitmentsControl } from 'views/Payment/MobilePayment/types'
import DepositByBuyCrypto from 'views/Payment/components/Deposit/DepositByBuyCrypto'
import PaymentCommitments from 'views/Payment/components/PaymentCommitments'
import DepositCryptos from './DepositCryptos'
import DepositFiat from './DepositFiat'

const Deposit: React.FC<{
  depositPage?: DepositOptionEnums
  onDismiss: () => void
  commitmentsControl: ICommitmentsControl
  onRedirect: (page: PaymentPageEnums) => void
}> = ({ depositPage = null, commitmentsControl, onRedirect }) => {
  const [depositOption, setDepositOption] = useState<DepositOptionEnums>(depositPage)
  const selectedTokenInit = useTokenSelected()
  const isDisabledFeaturedOnTelegram = useIsDisabledFeaturedOnTelegram()

  if (commitmentsControl.isShowCommitment) {
    return <PaymentCommitments commitmentsControl={commitmentsControl} />
  }

  if (isDisabledFeaturedOnTelegram) {
    return (
      <>
        <ModalHeader colorTheme={PAYMENT_MODAL_THEME} titleAlign="left" hideStroke title="Deposit" />
        <ModalBody>
          <OpenEffect openType="grow" duration={0.4}>
            <WarningOnTelegram />
          </OpenEffect>
        </ModalBody>
      </>
    )
  }

  if (!depositOption) {
    return (
      <>
        <ModalHeader colorTheme={PAYMENT_MODAL_THEME} titleAlign="left" hideStroke title="Deposit" />
        <ModalBody>
          <OpenEffect openType="grow" duration={0.4}>
            <Column gap="20px" height="100%">
              <DepositOptionContent onSelect={setDepositOption} commitmentsControl={commitmentsControl} />
            </Column>
          </OpenEffect>
        </ModalBody>
      </>
    )
  }

  if (depositOption === DepositOptionEnums.Fiat) {
    return <DepositFiat selectedTokenInit={selectedTokenInit} onBack={() => setDepositOption(null)} />
  }

  if (depositOption === DepositOptionEnums.BuyCrypto) {
    return (
      <>
        <ModalHeader
          useBackIcon
          hideStroke
          colorTheme={PAYMENT_MODAL_THEME}
          titleAlign="left"
          onBack={() => setDepositOption(null)}
          title={'Buy crypto using cards'}
        />

        <ModalBody>
          <DepositByBuyCrypto
            onNavigateToDeposit={() => {
              setDepositOption(DepositOptionEnums.Crypto)
            }}
          />
        </ModalBody>
      </>
    )
  }

  return (
    <DepositCryptos
      selectedTokenInit={selectedTokenInit}
      onBack={() => setDepositOption(null)}
      onRedirect={onRedirect}
    />
  )
}

export default Deposit
